import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0ba012e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c0ba012e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ba012e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ba012e')) {
      api.createRecord('c0ba012e', component.options)
    } else {
      api.reload('c0ba012e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0ba012e&scoped=true&", function () {
      api.rerender('c0ba012e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/informine/information/informationHome/index.vue"
export default component.exports